import useFetcher from 'hooks/useFetcher/useFetcher';
import { ServiceTypes } from 'hooks/useFetcher/interfaces';
import { stringifyUrl, getRequest } from 'utils';
import { Properties } from 'types';

export const useSettingsAPI = (): Properties => {
  const fetcher = useFetcher(ServiceTypes.CRM);

  return {
    getSettings: ({ queryKey: [, query] }) => {
      return fetcher(stringifyUrl(`/settings`, query), getRequest);
    },
    createSettings: (data) => {
      return fetcher('/settings', {
        data,
        request: {
          method: 'POST',
        },
      });
    },
  };
};
